import { useState } from "react";
import { Card, Label } from "../components/Primitives";
import buildGuide from "../data/guide";
import { useWorkouts, useMealPlan } from "../hooks/useApi";

export default function GuideView({ C, onBack }) {
  const { workouts } = useWorkouts();
  const { macroCaps, hasPlan } = useMealPlan();
  const mealPlan = hasPlan && macroCaps ? {
    calories: macroCaps.cal,
    protein: macroCaps.p,
    carbs: macroCaps.c,
    fat: macroCaps.f,
  } : null;
  const guideData = buildGuide({ workouts, mealPlan });

  const [categoryIndex, setCategoryIndex] = useState(0);
  const [openItem, setOpenItem] = useState(null);

  return (
    <div>
      <button
        onClick={onBack}
        style={{
          display: "flex", alignItems: "center", gap: 'var(--gap-sm)',
          background: "none", border: "none",
          color: C.accent, fontSize: 'var(--fs-body)', fontFamily: "var(--m)", fontWeight: 600,
          letterSpacing: ".06em", cursor: "pointer",
          padding: "0 0 16px", marginTop: -4,
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M15 18l-6-6 6-6" /></svg>
        BACK
      </button>

      <div style={{ fontSize: 'var(--fs-h1)', fontWeight: 700, color: C.text1, fontFamily: "var(--d)", marginBottom: 4 }}>
        Program Guide
      </div>
      <div style={{ fontSize: 'var(--fs-body)', color: C.text4, fontFamily: "var(--m)", marginBottom: 20 }}>
        Your personalized methodology, targets, and system
      </div>

      {/* Category Tabs */}
      <div style={{ display: "flex", gap: 'var(--gap-sm)', marginBottom: 20, overflowX: "auto" }}>
        {guideData.map((cat, i) => (
          <button
            key={i}
            onClick={() => {
              setCategoryIndex(i);
              setOpenItem(null);
            }}
            style={{
              padding: "6px 14px",
              background: i === categoryIndex ? `${C.accent}15` : "transparent",
              border: `1px solid ${i === categoryIndex ? C.accent : C.structBorderHover}`,
              borderRadius: 20,
              color: i === categoryIndex ? C.accent : C.text4,
              fontSize: 'var(--fs-xs)',
              fontWeight: 700,
              fontFamily: "var(--m)",
              letterSpacing: ".1em",
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "all 0.2s",
            }}
          >
            {cat.category}
          </button>
        ))}
      </div>

      {/* Items */}
      {guideData[categoryIndex]?.items.map((item, i) => (
        <Card
          key={i}
          C={C}
          onClick={() => setOpenItem(openItem === i ? null : i)}
          style={{ cursor: "pointer" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 'var(--fs-lg)', fontWeight: 600, color: C.text1 }}>
              {item.title}
            </div>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={C.text4} strokeWidth="2" strokeLinecap="round" style={{ transform: openItem === i ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.2s", flexShrink: 0 }}>
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          {openItem === i && (
            <div
              style={{
                fontSize: 'var(--fs-base)',
                color: C.text3,
                lineHeight: 1.8,
                marginTop: 12,
                paddingTop: 12,
                borderTop: `1px solid ${C.structBorder}`,
                fontFamily: "var(--m)",
              }}
            >
              {item.desc}
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}
